import { useState } from "react";
import '../assests/CSS/heroSection.css';
import Search from "./Search";
import hero_img from "../assests/images/sofa.png";

const HeroSection = () => {
    return (
        <section id="hero-section" className="hero-section">
            <div className="hero-content">
                <div className="hero-text">
                    <h2>Global Workforce & Employer Infrastructure Platform for Smarter Expansion</h2>
                    <p>
                        <span style={{ color: "#113157", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "1.5rem", paddingRight:"0.5rem" }}>.</span>
                        is dedicated to helping organizations, leaders, startups, and growth-focused enterprises expand globally by providing expert insights and tailored solutions in HR Tech, HCM, FinTech, and workforce management. Move beyond marketplace limitations and partner with us for smarter and faster expansion.
                    </p>
                    <Search />
                </div>
                <div className="hero-image">
                    <img src={hero_img} alt="B2B Service Marketplace" />
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
